import { Helmet } from 'react-helmet';
import { Slide, toast } from 'react-toastify';
import React, { memo, useEffect } from 'react';
import ModalRegistrar from '../../modals/ModalRegistrar';

const Wrapper = ({ children }) => {
  useEffect(() => {
    toast.configure({
      role: 'alert',
      hideProgressBar: true,
      transition: Slide,
      closeButton: false,
      position: 'bottom-right',
      pauseOnFocusLoss: false,
    });
  }, []);

  return (
    <>
      <Helmet>
        <html lang="fr" />
        <title>AFi24 CV - 2026</title>
        <meta
          name="description"
          content=""
        />
        <link rel="canonical" href="" />
        <meta property="og:url" content="" />
        <meta property="og:type" content="website" />
        <meta
          property="og:description"
          content=""
        />
        <meta property="og:image" content="" />
      </Helmet>

      {children}

      <ModalRegistrar />
    </>
  );
};

export default memo(Wrapper);
